<div class="host-modify-price-house-type-picker">
  <div class="filters border-b border-c-gs border-solid">
    <div class="row flex items-start mb-[10px]" *ngIf="listOfTagOption?.length">
      <div class="group mr-3">
        <div class="v4-filter-selectable" [class.selected]="tagId === null" (click)="onFilter(null)">
          {{ "price.batch.modal.house.filter.label_all" | translate }}
          <!-- 不限标签 -->
        </div>
      </div>
      <div class="v4-option-list">
        <div class="v4-option-item" *ngFor="let tag of listOfTagOption">
          <div
            style="background-color: #fff"
            class="v4-filter-selectable"
            [class.selected]="tagId === tag.value"
            (click)="onFilter(tag.value)"
          >
            {{ tag.label }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="content py-4 max-h-[400px] overflow-y-auto">
    <!--    <div class="operate" *ngIf="mode === 'multiple'">-->
    <!--      <span class="text-primary cursor-pointer mr-3" (click)="onSelectAll()">-->
    <!--        {{ "price.batch.modal.house.opt.select_all" | translate }}-->
    <!--         全选 -->
    <!--      </span>-->
    <!--      <span class="text-primary cursor-pointer" (click)="selectedTypes.clear()">-->
    <!--        {{ "price.batch.modal.house.opt.cancel_select_all" | translate }}-->
    <!--         取消选择 -->
    <!--      </span>-->
    <!--    </div>-->

    <div class="list">
      <ng-container *ngIf="listOfType?.length; else empty">
        <div class="v4-option-list">
          <div class="v4-option-item" *ngFor="let type of listOfType">
            <div class="v4-option" [class.selected]="selectedTypes.has(type.value)" (click)="onSelect(type.value)">
              {{ type.label }}
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #empty>
        <nz-empty></nz-empty>
      </ng-template>
    </div>
  </div>

  <div class="footer flex flex-row items-center justify-between">
    <div *ngIf="mode === 'multiple'">
      <a nz-button nzType="link" class="mr-3" (click)="onSelectAll()">{{
        "price.batch.modal.house.opt.select_all" | translate
      }}</a>
      <a nz-button nzType="link" (click)="selectedTypes.clear()">
        {{ "price.batch.modal.house.opt.cancel_select_all" | translate }}</a
      >
    </div>
    <div class="ml-auto">
      <button nz-button nzSize="large" class="mr-3" (click)="onCancel()">
        {{ "word.cancel" | translate }}
        <!-- 取消 -->
      </button>
      <button nz-button nzSize="large" nzType="primary" (click)="onConfirm()">
        {{ "word.confirm" | translate }}
        <!-- 确定 -->
      </button>
    </div>
  </div>
</div>
